if ($('#filter').length) {
  $(function () {
    // * Functions
    function appendInputs(data, location) {
      $.each(_.sortBy(data.areas), function (i, area) {
        if (!area.id || !area.displayName) return;
        location.append('<option value="' + area.id + '">' + area.displayName + '</option>');
      });
    }

    function enableAllInput() {
      $('.input-container').removeClass('disabled').prop('disabled', false);
      $('.see-results').removeClass('disabled').prop('disabled', false).prop('tabindex', '0');
      $('input[type="checkbox"]').removeClass('disabled').prop('disabled', false);
      $('input[type="checkbox"]').prop('tabindex', '0');
      $('.advanced-toggle a').removeClass('disabled').prop('tabindex', '0');
      $('.see-results').prop('disabled', false);

      $('.irs-slider.from, .irs-slider.to').each(function () {
        $(this).attr('tabindex', '0');
      });
    }

    function disableAllInput() {
      $('.input-container:not([name="area"])').addClass('disabled').prop('disabled', true);
      $('.see-results').addClass('disabled').prop('disabled', true).prop('tabindex', '-1');
      $('input[type="checkbox"]').addClass('disabled').prop('disabled', true);
      $('input[type="checkbox"]').prop('tabindex', '-1');
      $('#contact-form-modal input[type="checkbox"]').removeClass('disabled').prop('disabled', false);
      $('#contact-form-modal input[type="checkbox"]').prop('tabindex', '0');
      $('.advanced-toggle a').not('.bottom').addClass('disabled').prop('tabindex', '-1');
      $('.see-results').prop('disabled', true);

      $('.irs-slider.from, .irs-slider.to').each(function () {
        $(this).attr('tabindex', '-1');
      });
    }

    function scrollToTheTop() {
      // * Scroll back to top
      var distance = $('.community-filter').offset().top;
      var offset = $('.nav--main').height();

      $('html, body').animate({
        scrollTop: (distance - offset)
      }, 1000);

      $('.see-results.see-results-top').removeClass('hidden').css('display', 'block');
    }

    function resetFilters() {

      // * Reset the sliders
      $('.slider').each(function () {
        var slider = $(this).data('ionRangeSlider');
        slider.reset();
      });

      // * Reset the checkboxes
      $('.community-filter input[type="checkbox"]').each(function () {
        $(this).prop('checked', false);
      });

      $('#show-mir').prop('checked', true);

      // * Reset text inputs
      $('input[type=text]').each(function () {
        $(this).val('');
      });

      // * Reset selects
      $('select[name=commute-miles], select[name=move-in], select[name=school-district], select[name=neighborhood-select]').val('').change();

      // * Reset Mobile Filter Toggle
      $('.community-toggle.main').parent().toggleClass('hidden');

      // * Reset sort order
      $('#sort').val('').change();
      $('#distance-option').prop('disabled', true);

      $('a.reset-filters.reset-filters-top').removeClass('hidden').css('display', 'block');
      // * Scroll back to top
      scrollToTheTop();

    }

    function getSchoolDistricts() {
      $('select[name=school-district]').parent().addClass('disabled').prop('disabled', true);
      if ($('#region-select').val()) {
        var term = $('#region-select').val();
        if ($('#neighborhood-select').val()) {
          term = $('#neighborhood-select').val();
        }

        $.getJSON('/data/districts/' + term + '.json', function (data) {
          appendInputs(data, $('#school-district'));
        }).always(function (data) {
          if (data.areas) {
            $('select[name=school-district]').parent().removeClass('disabled').prop('disabled', false);
          } else {
            $('select[name=school-district]').parent().addClass('disabled').prop('disabled', true);
          }
        });
      }
    }

    // * Commute distance variance
    $('#commute').on('change', function () {
      if (/(^\d{5}$)|(^\d{5}-\d{4}$)/.test($(this).val())) {
        $('#distance-option').prop('disabled', false);
      } else {
        if ($('#sort').val() == 'distance') $('#sort').val('').change();
        $('#distance-option').prop('disabled', true);
      }
    });

    // * Reset filter button
    $('a.reset-filters-top').on('click tap', function (e) {
      e.preventDefault();
      resetFilters();
    });

    $('a.reset-filters-advanced').on('click tap', function (e) {
      e.preventDefault();
      // * Close advanced area
      $('.advanced-toggle a').first().fadeToggle('fast', function () {
        $('.see-results.see-results-top').addClass('hidden');
        $('.advanced').fadeToggle('fast', function () {
          if (!$('#advanced').is(':visible')) {
            scrollToTheTop();
          }
        });
      });
      resetFilters();
    });

    if ($('a.reset-filters-advanced-short').length) {
      $('a.reset-filters-advanced-short').on('click tap', function () {
        resetFilters();
      });
    }

    // * Advanced toggle button
    $('.advanced-toggle a').on('click tap', function (e) {
      if (e && $('.advanced-toggle a').first().hasClass('disabled') && $('.advanced').is(':hidden')) return false;
      $('.community-toggle.main').parent().toggleClass('hidden');
      $('.advanced-toggle a').first().fadeToggle('fast', function () {
        if (!$('a.reset-filters.reset-filters-top').hasClass('hidden')) {
          $('a.reset-filters.reset-filters-top').addClass('hidden');
        } else {
          $('a.reset-filters.reset-filters-top').removeClass('hidden');
        }
        if (!$('.see-results.see-results-top').hasClass('hidden')) {
          $('.see-results.see-results-top').addClass('hidden');
        } else {
          $('.see-results.see-results-top').removeClass('hidden');
        }
        $('.advanced').fadeToggle('fast', function () {

          if (!$('#advanced').is(':visible')) {
            scrollToTheTop();
          }
        });
      });
    });

    $('#region-select').on('change', function () {
      var neighborhoodSelect = $('#neighborhood-select');
      neighborhoodSelect.prop('disabled', true);
      neighborhoodSelect.find('option').first().nextAll().remove();

      var schoolDistrict = $('select[name=school-district]');
      schoolDistrict.val('').change();
      schoolDistrict.parent().addClass('disabled').prop('disabled', true);
      schoolDistrict.find('option').first().nextAll().remove();

      var value = $(this).val();
      if (value !== '') {
        enableAllInput();
        $.getJSON('/data/neighborhoods/' + value + '.json', function (data) {
          appendInputs(data, neighborhoodSelect);
        }).done(function () {
          neighborhoodSelect.prop('disabled', false);
        }).always(function () {
          getSchoolDistricts();
        });

      } else {
        $('.see-results').addClass('disabled').prop('disabled', true).prop('tabindex', '-1');
      }
    });

    // * Handle pageload pre-select
    $('#region-select').change();

    $('#neighborhood-select').on('change', function () {
      var schoolDistrict = $('select[name=school-district]');
      schoolDistrict.val('').change();
      schoolDistrict.parent().addClass('disabled').prop('disabled', true);
      schoolDistrict.find('option').first().nextAll().remove();
      getSchoolDistricts();
    });

    // * Show on mobile
    $('.community-toggle a').on('click tap', function () {
      $('.community-toggle').first().toggleClass('hidden');
      $('.community-filter').first().toggleClass('hide-for-small-only');
      if ($('.community-filter').first().hasClass('hide-for-small-only')) {
        $('.advanced').addClass('hide-for-small-only');
      } else {
        $('.advanced').removeClass('hide-for-small-only');
      }
    });

    $('.hide-filters').on('click tap', function () {
      $('.advanced-toggle a').first().fadeToggle('fast', function () {
        $('.see-results.see-results-advanced').toggleClass('hidden');
        $('.advanced').fadeToggle('fast');
      });
      $('.community-toggle.main').parent().toggleClass('hidden');
      $('.community-toggle').first().toggleClass('hidden');
      $('.community-filter').first().toggleClass('hide-for-small-only');
    });

    // * https://github.com/IonDen/ion.rangeSlider
    $('#pricerange-slider').ionRangeSlider({
      type: 'double',
      prefix: '$',
      min: 100000,
      max: 1500000,
      step: 25000,
      prettify_separator: ',',
      grid: false,
      hide_min_max: true,
      force_edges: true,
      keyboard: true
    });

    $('#sqft-slider').ionRangeSlider({
      type: 'double',
      postfix: ' sq. ft.',
      min: 750,
      max: 6000,
      step: 250,
      prettify_separator: ',',
      grid: false,
      hide_min_max: true,
      force_edges: true,
      keyboard: true
    });

    $('#payment-slider').ionRangeSlider({
      type: 'double',
      prefix: '$',
      min: 750,
      max: 5000,
      step: 250,
      prettify_separator: ',',
      grid: false,
      hide_min_max: true,
      force_edges: true,
      keyboard: true
    });

    $('.input-container:not(.disabled) .irs-slider.from, .input-container:not(.disabled) .irs-slider.to').each(function () {
      $(this).attr('tabindex', '-1');
    });

    $('.input-container').on('keyup', function (e) {
      var code = (e.keyCode ? e.keyCode : e.which);
      if (code == 9 && $('.irs-slider:focus').length) {
        $('.irs-slider:focus').click();
      }
    });

    $('.filters-toggle').on('click', function () {
      scrollToTheTop();
      $('.filter-wrap').fadeToggle(800, function () {
        var icon = $('.filters-toggle').find('i');
        if (icon.hasClass('fa-chevron-down')) {
          icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
        } else if (icon.hasClass('fa-chevron-up')) {
          icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
        }
        scrollToTheTop();
      });
    });
  });

}